module.exports = __webpack_public_path__ + "img/plan2_s.68182b68.svg";